import { MessageCircle, Plus, RefreshCw } from "lucide-react";
import { Button, EmptyState, NoticeBox, Tags } from "../ui";
import { categoryLabel } from "./copilotText";
import { formatListTime } from "./format";

const senderPrefix = (message, t) => {
  if (!message) return "";
  if (message.senderType === "customer") return `${t.you}: `;
  return "";
};

const STATUS_VARIANT = { open: "success", pending: "warning", resolved: "neutral" };

export default function ConversationList({ c, lang }) {
  const { t, list, mode, categories } = c;
  const isGuest = mode === "guest";

  return (
    <div className="lc-list">
      <div className="lc-list-bar">
        <h3 className="lc-section-title">{t.conversations}</h3>
        <Button variant="primary" appearance="filled" size="sm" icon={<Plus size={14} />} onClick={() => c.startIntake()}>
          {t.newConversation}
        </Button>
      </div>

      {(list.status === "loading" || list.status === "idle") && (
        <div className="lc-skeletons" role="status" aria-label={t.loading}>
          {[0, 1, 2].map((i) => (
            <div className="lc-skeleton" key={i} />
          ))}
        </div>
      )}

      {list.status === "error" && (
        <EmptyState variant="error" action={<Button variant="neutral" appearance="outline" size="sm" icon={<RefreshCw size={14} />} onClick={() => c.loadList()}>{t.retry}</Button>}>
          {list.error || t.listError}
        </EmptyState>
      )}

      {list.status === "ready" && list.items.length === 0 && (
        <EmptyState icon={<MessageCircle size={34} />} title={t.emptyTitle}>{isGuest ? t.emptyGuest : t.emptyBody}</EmptyState>
      )}

      {list.items.length > 0 && (
        <ul className="lc-items">
          {list.items.map((item) => (
            <li key={item.id}>
              <button type="button" className={`lc-item ${item.unreadCount ? "unread" : ""}`} onClick={() => c.openConversation(item.id)}>
                <span className="lc-item-top">
                  <span className="lc-item-subject">{item.subject}</span>
                  <span className="lc-item-time">{formatListTime(item.lastActivityAt, lang)}</span>
                </span>
                <span className="lc-item-preview">
                  {senderPrefix(item.lastMessage, t)}
                  {item.lastMessage?.text || ""}
                </span>
                <span className="lc-item-meta">
                  <Tags size="sm" variant={STATUS_VARIANT[item.status] || "neutral"}>{t.status[item.status] || item.status}</Tags>
                  <span className="lc-item-category">{categoryLabel(categories, item.category, lang)}</span>
                  <span className="lc-item-ref" dir="ltr">{item.reference}</span>
                  {item.unreadCount > 0 && (
                    <span className="lc-unread-dot" role="img" aria-label={t.unread(item.unreadCount)}>
                      {item.unreadCount > 9 ? "9+" : item.unreadCount}
                    </span>
                  )}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}

      {list.hasMore && (
        <div className="lc-more">
          <Button variant="neutral" appearance="outline" size="sm" loading={list.loadingMore} onClick={c.loadMore}>
            {t.loadMore}
          </Button>
        </div>
      )}
      {list.status === "ready" && list.error && <NoticeBox variant="danger" size="sm" className="lc-list-error">{list.error}</NoticeBox>}
      {isGuest && <p className="lc-footnote">{t.guestNote}</p>}
    </div>
  );
}
